import React from 'react';
import './styles.scss';


function CardPlayer(props) {
  return (
    <div className={'card card-players'}>
      <div className={'card-container'}>
        <div className={'preview-container'}>
          {props.image !== '' &&
          <div
            className='card-cover'
            style={{ backgroundImage: `url(${props.image})`, backgroundSize: 'cover' }}
          />
          }
        </div>
      </div>
      <div className='card-labels-container'>
        <div className="card-player-name">
          <span className={`subtitle-bottom ${props.changeWeight ? 'subtitleWeight' : ''}`}>{props.name}</span>
        </div>
      </div>
    </div>
  );
}

export default CardPlayer;



// WEBPACK FOOTER //
// ./src/mundial/RibbonTypes/CardsTypesMundial/PlayersCard/index.js